import { Card } from '@ipfabric/ui-components/Card/Card';
import { createFormSnippetGroup } from '@ipfabric/ui-components/utils/formSnippets/FormSnippetGroup';
import { SearchableSection } from '../../../components/DiscoverySearch/SearchableSection';
import { storedAimApplications } from '../../../snippets/storedAimApplications';
import type { DiscoverySettingsGroupDisplayControl } from '../DiscoverySettings';

export const aimApplicationsGroup = createFormSnippetGroup({
  snippets: {
    aimApplications: storedAimApplications,
  },
  render: ({ renderSnippet }) => (
    <SearchableSection
      id='aim-applications'
      searchTerms={['Application list']}
      highlightOn={['aimApplications']}
      className='flex flex-col flex-1'
      wrapperClassName='flex flex-col flex-1'
    >
      <Card className='flex flex-col flex-1 rounded-tl-none' noShadow>
        <SearchableSection
          id='aim-applications'
          className='flex flex-col flex-1'
          wrapperClassName='flex flex-col flex-1'
          highlightOn={['applicationMapping']}
        >
          {renderSnippet('aimApplications')}
        </SearchableSection>
      </Card>
    </SearchableSection>
  ),
  show: (control: DiscoverySettingsGroupDisplayControl) => {
    control.setTab('applicationMapping');
    control.setApplicationMappingSubTab('aimApplications');
  },
});
